module.exports = __webpack_public_path__ + "img/figuurb02.96404270.png";